import React from 'react';
import { usePublishedSites } from '../helpers/useCloudflareApi';
import { Badge } from './Badge';
import { Skeleton } from './Skeleton';
import { PublishedSiteItem } from './PublishedSiteItem';
import { Globe } from 'lucide-react';
import styles from './PublishedSitesPanel.module.css';

interface PublishedSitesPanelProps {
  sessionId: string;
}

export const PublishedSitesPanel: React.FC<PublishedSitesPanelProps> = ({ sessionId }) => {
  const { data, isLoading, error } = usePublishedSites(sessionId);

  if (isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <h3 className={styles.title}>Published Sites</h3>
        </div>
        <div className={styles.list}>
          {[1, 2].map((i) => (
            <div key={i} className={styles.skeletonItem}>
              <Skeleton style={{ width: '100%', height: '80px' }} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <div className={styles.errorState}>
          <p>Failed to load published sites.</p>
        </div>
      </div>
    );
  }

  const sites = data?.sites || [];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Published Sites</h3>
        <Badge variant="secondary" className={styles.countBadge}>
          {sites.length}
        </Badge>
      </div>

      {sites.length === 0 ? (
        <div className={styles.emptyState}>
          <Globe className={styles.emptyIcon} size={32} />
          <p className={styles.emptyText}>No sites published yet.</p>
          <p className={styles.emptySubtext}>
            Use the &quot;Publish&quot; button in the toolbar to deploy your code.
          </p>
        </div>
      ) : (
        <div className={styles.list}>
          {sites.map((site) => (
            <PublishedSiteItem key={site.id} site={site} />
          ))}
        </div>
      )}
    </div>
  );
};
